import {
  Autocomplete,
  FormControl,
  MenuItem,
  Select,
  TextField,
} from "@mui/material";
import "react-calendar/dist/Calendar.css";
import "../../sass/components/Filters/ProjectDeadlineFilter.scss";

const MONTHS_OPTIONS = ["1", "3", "6", "12", "18", "24", "36", "48", "60"];
const FILTER_OPTIONS = ["Up to", "At least"];

export default function ProjectDeadlineFilter({
  value,
  setValue,
  open,
  setOpen,
  title = "Collab Duration",
  showFilterType = true,
  selectedOption,
  setSelectedOption,
  isAdd,
}: {
  value: number;
  setValue: (newState: number) => void;
  open: boolean;
  setOpen: (key: string) => void;
  title?: string;
  showFilterType?: boolean;
  selectedOption?: string;
  setSelectedOption?: (newState: string) => void;
  isAdd?: boolean;
}) {
  const handleOpen = () => {
    setOpen("projectDeadline");
  };

  return (
    <div className="component set_border_2_grey">
      <div onClick={handleOpen} className="title">
        <p>
          {title}&nbsp;
          {value > 0 && <span className="ml_3">({value} months)</span>}
        </p>
        <i
          className={`${
            open && "rotate"
          } fa-solid fa-chevron-down cursor-pointer`}
        />
      </div>
      {open && (
        <div
          className="show_component"
          style={
            isAdd
              ? { left: 0, right: 0, borderLeft: 0, borderRight: 0 }
              : undefined
          }
        >
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              width: "100%",
              gap: "8px",
              alignItems: "center",
              justifyContent: "center",
              padding: "6px 0",
            }}
          >
            {/* Filter Type Selector */}
            {showFilterType && (
              <FormControl style={{ flex: 1, minWidth: 0 }}>
                <Select
                  value={selectedOption || "Up to"}
                  onChange={(e) =>
                    setSelectedOption && setSelectedOption(e.target.value)
                  }
                  style={{
                    borderRadius: 4,
                    background: "#fff",
                    fontSize: "10px",
                    height: "20px !important",
                    lineHeight: "20px !important",
                    minHeight: "20px !important",
                    maxHeight: "20px !important",
                  }}
                  size="small"
                  MenuProps={{
                    PaperProps: {
                      style: {
                        maxHeight: 100,
                        fontSize: "10px",
                        zIndex: 99999,
                      },
                    },
                    sx: {
                      zIndex: 99999,
                    },
                  }}
                >
                  {FILTER_OPTIONS.map((option) => (
                    <MenuItem
                      key={option}
                      value={option}
                      style={{
                        fontSize: "10px",
                        height: "20px",
                        lineHeight: "20px",
                      }}
                    >
                      {option}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            )}

            {/* Months Input */}
            <Autocomplete
              freeSolo={false}
              options={MONTHS_OPTIONS}
              value={
                MONTHS_OPTIONS.includes(value?.toString())
                  ? value?.toString()
                  : null
              }
              onChange={(_, val) => {
                if (!val) {
                  setValue(0);
                } else {
                  const num = Number(val);
                  setValue(!isNaN(num) && num > 60 ? 60 : num);
                }
              }}
              onInputChange={(_, value, reason) => {
                if (value === "" || value === undefined) {
                  setValue(0);
                } else {
                  const num = Number(value);
                  if (!isNaN(num) && num > 60) {
                    setValue(60);
                  } else {
                    setValue(Number(value));
                  }
                }
              }}
              renderInput={(params) => (
                <TextField
                  {...params}
                  placeholder="Months"
                  type="number"
                  variant="outlined"
                  size="small"
                  InputProps={{
                    ...params.InputProps,
                    style: {
                      borderRadius: 4,
                      background: "#fff",
                      fontSize: "10px",
                      height: "20px !important",
                      lineHeight: "20px !important",
                      minHeight: "20px !important",
                      maxHeight: "20px !important",
                    },
                  }}
                  style={{
                    borderRadius: 4,
                    background: "#fff",
                    fontSize: "10px",
                  }}
                  onKeyDown={(e) => {
                    const input = e.currentTarget as HTMLInputElement;
                    if (
                      (e.key === "Backspace" || e.key === "Delete") &&
                      input.value === ""
                    ) {
                      setValue(0);
                    }
                    if (e.key === "Enter") {
                      if (input.value === "") {
                        setValue(0);
                      } else if (Number(input.value) > 60) {
                        setValue(60);
                      }
                    }
                  }}
                />
              )}
              ListboxProps={{
                style: {
                  maxHeight: 100,
                  borderRadius: 4,
                  fontSize: "10px",
                  zIndex: 99999,
                },
              }}
              slotProps={{
                popper: {
                  sx: {
                    zIndex: 99999,
                  },
                },
              }}
              style={{ flex: 1, minWidth: 0 }}
            />
          </div>
        </div>
      )}
    </div>
  );
}
